import styled from '@emotion/styled'
import { InputLabel } from '@mui/material'
import { color as configColor } from 'config/color'

export const FormLabel = styled(InputLabel)<{ textcolor?: string, marginBottom?: number }>(
  ({ textcolor, marginBottom }) => ({
    fontSize: 12,
    color: textcolor ?? configColor.grey[900],
    textTransform: 'uppercase',
    letterSpacing: 2,
    marginBottom: marginBottom ?? 5,
    whiteSpace: 'normal',
    wordWrap: 'break-word'
  })
)
